export default class Gallery {
  constructor(element) {
    this.element = element;
    this.galleryImg = document.querySelectorAll('.gallery-img-js');
    this.mainImg = document.getElementById('mainImg');
    this.currentIndex = 0;
    this.delay = 3000;
    this.intervalId = null;

    this.init();
  }

  init() {
    // Clic sur les miniatures
    this.galleryImg.forEach((img, index) => {
      img.addEventListener('click', () => {
        this.changeImage(img);
        this.currentIndex = index;
        this.restartAutoSwitch();
      });
    });

    this.startAutoSwitch();
  }

  startAutoSwitch() {
    this.intervalId = setInterval(() => {
      const nextImg = this.galleryImg[this.currentIndex];
      this.changeImage(nextImg);
      this.currentIndex = (this.currentIndex + 1) % this.galleryImg.length;
    }, this.delay);
  }

  restartAutoSwitch() {
    clearInterval(this.intervalId);
    this.startAutoSwitch();
  }

  changeImage(element) {
    // Retirer la classe 'active' de toutes les miniatures
    this.galleryImg.forEach((t) => t.classList.remove('active'));

    // Ajouter la classe 'active' à la miniature sélectionnée
    element.classList.add('active');

    // Changer l'image principale
    this.mainImg.src = element.src;
  }
}
